import { uploadFileToS3Api } from "../api/customerAPI";

export const downloadFileFromS3 = async (
  documentId: string,
  filename: string
) => {
  try {
    if (!documentId) {
      throw new Error("No document ID found.");
    }

    const response = await fetch(documentId, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error("Failed to download the PDF.");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading the file:", error);
  }
};

export const uploadSingleFileWithPresignedUrl = async (
  presignedUrl: string,
  binaryData: File | Blob,
  fileType: string
) => {
  try {
    const blobData =
      binaryData instanceof Blob
        ? binaryData
        : new Blob([binaryData], { type: fileType });

    const response: any = await uploadFileToS3Api(
      presignedUrl,
      blobData,
      fileType
    );

    return response;
  } catch (error) {
    console.error("Error uploading file:", error);
    throw new Error("File upload failed");
  }
};

export interface AgreementFormData {
  clientName: string;
  clientAddress: string;
  clientRepresentativeName: string;
  executionDate: string;
  agreementDate: string;
  clientPaymentDetails: string;
  sellerAccountDetails: string;
  amountInFigures: number;
  amountInWords: string;
  depositAmountInFigures: number;
  products: { name: string; price: number }[];
  assets: { name: string; quantity: number }[];
}
